"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLatest = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var array_1 = require("../../array");
var use_previous_1 = require("../use-previous");
/**
 * @description RxJSのmergeと似た動作をするhooks．
 * 引数のうち最後に更新された値を返す．
 * @example
 *   const [value1, setValue1] = useState<number>(0)
 *   const [value2, setValue2] = useState<string>('0')
 *   const latest = useLatest(value1, value2)  // number | string
 */
var useLatest = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var _a = tslib_1.__read((0, react_1.useState)(values[0]), 2), latest = _a[0], setLatest = _a[1];
    var prevValues = (0, use_previous_1.usePrevious)(values);
    (0, react_1.useEffect)(function () {
        var e_1, _a;
        if (prevValues === undefined) {
            setLatest(values[0]);
        }
        else {
            try {
                for (var _b = tslib_1.__values(array_1.array.zip(prevValues, values).values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = tslib_1.__read(_c.value, 2), prev = _d[0], curr = _d[1];
                    if (prev !== curr) {
                        setLatest(curr);
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    }, [values, prevValues]);
    return latest;
};
exports.useLatest = useLatest;
